import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QuestionPrompt from '../QuestionPrompt';
import DialogPrompt from '../DialogPrompt';
import BadgeCollect from '../../badges/BadgeCollect';
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Option from './OrderingMatchingOptionReview';
import Feedback from './OrderingMatchingFeedbackReview';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as componentConstants from '../../../../constants/componentConstants';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import _ from 'lodash';

class OrderingMatchingReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            screenObject: props.screenObject,
            userData: props.userData,
            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
            locale: appHelper.getLocalData(this.props.screenObject),
            outcomeLocale: {},
            questionChecked: false,
            correctAnswerCount: appHelper.getTypeCount(props.screenObject.options, "result", "best").length,
            responseData: props.responseData,
            options: props.responseData.userSelections,
            showOptions: true,
            showCheckBtn: false,
            showFeedback: true,
            checkAnswers: true,
            //badges
            badgesEarned:[],
            checkBadgesEarned: false,
            collected: true,
            character_name: appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            showCorrectResponseControls: false,
            showUserResponses: true,
            show_correct_answers_label:appHelper.getLocaleString("show_correct_answers_label"),
            show_my_answers_label:appHelper.getLocaleString("show_my_answers_label"),
            labelWidth: 0,
            longestOption:{},
            allowAudioAutoPlay: false,
        };
        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.checkAnswers = this.checkAnswers.bind(this);
        this.showFeedback = this.showFeedback.bind(this);
        //badges
        this.checkBadgeEarnedOnObject = this.checkBadgeEarnedOnObject.bind(this);
        this.getBadge = this.getBadge.bind(this);
        this.toggleUserAnswers = this.toggleUserAnswers.bind(this);
        this.setLabelWidth = this.setLabelWidth.bind(this);

    }

    componentDidMount() {
        this.checkAnswers();
        this.checkBadgeEarnedOnObject();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkBadgesEarned: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                show_correct_answers_label:appHelper.getLocaleString("show_correct_answers_label"),
                show_my_answers_label:appHelper.getLocaleString("show_my_answers_label"),
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkAnswers) {
            this.checkAnswers();
        }

        if(this.checkBadgesEarned){
            this.checkBadgeEarnedOnObject();
        }
    }

    checkBadgeEarnedOnObject(){
        let params = {
            bite_id: this.state.responseData.bite_id,
            asset_id: this.state.screenObject.asset_id
        };

        let badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
        this.setState({
            checkBadgesEarned: false,
            badgesEarned: Object.assign([],badgesEarned)
        });
    }

    getBadge(badge_id){
        //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
    }

    randomiseOptions() {
        this.setState({
            screenObject: Object.assign({}, this.state.screenObject, {
                options: dataHelper.randomiseArray(this.state.screenObject.options)
            })
        });
    }

    renderOptions() {
        if (!this.state.showOptions && this.state.responseData.currentStatus == objectConstants.STATUS_NOT_STARTED) {
            this.setState({showOptions: true});
        }
    }

    onOptionClick(option) {
        let locale_checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
        let optionIndex = appHelper.getArrayObjectIndexByKey(locale_checkedOptions, "option_id", option.option_id);
        if (optionIndex == -1) {
            locale_checkedOptions = dataHelper.immutablePush(locale_checkedOptions, option);
        } else {
            locale_checkedOptions = dataHelper.immutableSplice(locale_checkedOptions, optionIndex, 1);
        }

        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length, option),
                    userSelections: Object.assign([], this.state.responseData.userSelections),
                    initialised: true
                }
            ),
            showFeedback: true,
            showCheckBtn: locale_checkedOptions.length > 0,
            checkAnswers: false,
        });
    }

    //checkedOptions
    checkAnswers() {

        let correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "is_correct", true);
        let incorrectAnswers = appHelper.getNotOfTypeCount(this.state.responseData.checkedOptions,"is_correct", true);

        let outcome = {};
        if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"));
        } else {
            //if (this.state.screenObject.allowPartlyCorrectResponses) {

            if (correctAnswers.length > 0) {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"));
                if (!appHelper.isDefined(outcome.result)) {
                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"));
                }
            } else {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"));
            }
            /*} else {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result_type", "incorrect"));
            }*/
        }

        if(this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE){
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"),{
                result: "reflective"
            });
        }

        let outcomeLocale = appHelper.getLocalData(outcome);

        let firstCheckedOption = {};
        for (let i = 0; i < this.state.screenObject.options.length; i++) {
            let option = this.state.screenObject.options[i];
            let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", option.option_id);
            if (checkedIndex > -1) {
                firstCheckedOption = Object.assign({}, option);
                break;
            }
        }

        let longestOption = this.state.screenObject.options[0];
        let optionLabelLength = 0;
        if(this.state.screenObject.asset_type_code === componentConstants.MATCHING) {
            _.forEach(this.state.screenObject.options, function (option, index) {

                    let optionLocale = appHelper.getLocalData(option);
                    if(optionLocale.option.length > optionLabelLength){
                        optionLabelLength = optionLocale.option.length;
                        longestOption = Object.assign({},option);

                    }

            });
        }

        //console.log(`longestOption`,longestOption);
        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    outcome: outcome,
                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length, firstCheckedOption)
                }
            ),
            showFeedback: true,
            questionChecked: true,
            checkAnswers: false,
            outcomeLocale: outcomeLocale,
            showCorrectResponseControls: outcome.result !== "best" && outcome.feedback_settings.show_correct_answers_controls && this.state.screenObject.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE,
            longestOption: Object.assign({},longestOption),

        });
    }

    showFeedback() {
        // console.log("showFeedback");
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
            this.setState({showFeedback: true});
        }
    }



    toggleUserAnswers(){
        this.setState({showUserResponses: !this.state.showUserResponses});
    }

    setLabelWidth(labelWidth){
        if(labelWidth > 0){
            this.setState(
                {
                    labelWidth: labelWidth
                }
            );
            //console.log(`setLabelWidth`,labelWidth);
        }
    }

    render() {
        return (
            <div className="learner-action">
                {
                    this.state.badgesEarned.length > 0
                        ?
                        <div>
                            {this.state.badgesEarned.map(badge =>
                                <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id} bite_id={this.state.responseData.bite_id} asset_id={this.state.responseData.asset_id} collected={this.state.collected}/>
                            )}
                            <br/>
                        </div>
                        : null
                }

                {this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                    ?
                    <div className="object-container">
                        <DialogPrompt character_name={this.state.character_name}
                                      screenObject={this.state.screenObject}
                                      onComplete={this.renderOptions}
                                      allowAudioAutoPlay={this.state.allowAudioAutoPlay}/>
                    </div>
                    :

                    <QuestionPrompt screenObject={this.state.screenObject} onComplete={this.renderOptions} allowAudioAutoPlay={this.state.allowAudioAutoPlay}/>


                }
                {this.state.showOptions
                    ?
                    <div className="text-center">
                        <div className="ordering-option-list theme-active"
                             id={`${this.state.screenObject.asset_id}_questionOptions`}
                             ref={`${this.state.screenObject.asset_id}_questionOptions`}>
                            {this.state.options.map(option =>
                                <Option key={`option_${option.option_id}`}
                                        asset_type_code={this.state.screenObject.asset_type_code}
                                        option={option}
                                        asset_id={this.state.screenObject.asset_id}
                                        responseData={this.state.responseData}
                                        showCorrectResponseControls={this.state.showCorrectResponseControls}
                                        showUserResponses={this.state.showUserResponses}
                                        scoring_type={this.state.screenObject.scoring_type}
                                        setLabelWidth={this.setLabelWidth}
                                        labelWidth={this.state.labelWidth}
                                        longestOption={this.state.longestOption}
                                />
                            )}
                        </div>
                    </div>
                    : null
                }

                {this.state.showCorrectResponseControls
                    ?
                    <div>
                        <Button label={this.state.showUserResponses ? this.state.show_correct_answers_label : this.state.show_my_answers_label}
                                id={`${this.state.screenObject.asset_id}_showCorrectAnswersButton`}
                                onClick={this.toggleUserAnswers}/>
                    </div>
                    :
                    null
                }

                {
                    this.state.showFeedback && appHelper.isDefined(this.state.outcomeLocale.feedback) && this.state.outcomeLocale.feedback.length > 0
                        ? <Feedback showUserResponses={this.state.showUserResponses}
                                                        asset_id={this.state.screenObject.asset_id}
                                                        responseData={this.state.responseData}
                                                        outcome={this.state.showUserResponses ? this.state.responseData.outcome : appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best")}

                        />
                        : null
                }

            </div>
        );
    }
}

OrderingMatchingReview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    responseData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

OrderingMatchingReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderingMatchingReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/orderingMatching/OrderingMatchingReview.js
 **/